import { pickHighestContrastColorRelaxed } from "../../lib/display-utils";
import primitives from "./primitives";

export const textColorOn = (color: string): string =>
  pickHighestContrastColorRelaxed(
    color,
    primitives.dark.neutral["0"],
    primitives.dark.neutral["950"],
  );
